// extracted by mini-css-extract-plugin
module.exports = {"tabsContainer":"EnergyProTile_tabsContainer__APsh3","tab":"EnergyProTile_tab__23doZ","tabIcon":"EnergyProTile_tabIcon__19Z-k"};